export default {
  booker: () => import("/opt/buildhome/repo/layouts/booker.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  public: () => import("/opt/buildhome/repo/layouts/public.vue").then(m => m.default || m)
}